import { useState } from 'react';
import ReactPlayer from 'react-player';
import { classnames } from 'tailwindcss-classnames';
import Image from 'next/image';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';

interface VideoWrapperProps {
  source: string;
  isTopControl?: boolean;
  isDisabled?: boolean;
}

const VideoWrapper = ({ source, isTopControl, isDisabled }: VideoWrapperProps): JSX.Element => {
  const [isPlaying, setPlaying] = useState(true);
  const playButton = '/static/videoButton/video_play_black.png';
  const pauseButton = '/static/videoButton/video_pause_black.png';

  const isExperienceEditor = useExperienceEditor();
  if (isExperienceEditor) {
    return (
      <div
        className={classnames(
          'absolute',
          'z-10',
          'p-3',
          'text-white',
          'text-2xl',
          'font-semibold',
          'top-0',
          'right-0'
        )}
      >
        Warning: Video is disabled in Experience Editor
      </div>
    );
  }

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    setPlaying(!isPlaying);
  };

  const locationClasses = isTopControl
    ? classnames('mt-6', 'md:mt-12', 'top-0')
    : classnames('mb-6', 'md:mb-12', 'bottom-0');

  return (
    <>
      <ReactPlayer
        src={source}
        width="auto"
        height="auto"
        playing={isPlaying}
        loop
        muted
        playsInline
        className={classnames('grow', 'object-cover', 'self-stretch')}
      />
      <button
        disabled={isDisabled}
        onClick={handleClick}
        type="button"
        className={classnames(
          locationClasses,
          'opacity-65',
          'absolute',
          'z-10',
          'w-12',
          'h-12',
          'right-0',
          'mr-6',
          'md:mr-12',
          'rounded-3xl',
          'hover:opacity-85',
          'disabled:opacity-30',
          'focus-visible:outline-2',
          'focus-visible:outline-white',
          'focus-visible:outline'
        )}
      >
        <Image
          src={isPlaying ? pauseButton : playButton}
          width="48"
          height="48"
          alt={isPlaying ? 'Pause' : 'Play'}
        />
      </button>
    </>
  );
};

export default VideoWrapper;
